<script lang="ts" setup>
import { useRouter } from 'vue-router'
import { useAdminStore } from '@/modules/admin/store/adminStore'

import SectionHeader from '@/components/SectionHeader.vue'

import type { IAdminOption } from '@/modules/admin/types/IAdminOption'

const router = useRouter()
const adminStore = useAdminStore()

const routeToOption = async (option: IAdminOption) => {
   if (!option) return
   await router.push({ name: option.route })
}

console.log('ListOptions', adminStore.adminOptions)
</script>

<template>
  <div class="pa-4 d-flex flex-column ga-2">
    <header>
      <section-header />
    </header>

    <VList border rounded="lg">
      <VListItem
        v-for="option in adminStore.adminOptions"
        :key="option.route"
        :value="option.route"
        link
        @click="routeToOption(option)"
      >
        <VListItemTitle class="text-body-1 text-wrap">
          {{ option.name }}
        </VListItemTitle>

        <template #append>
          <VIcon icon="ri-arrow-right-s-line" size="20" opacity="0.5" />
        </template>
      </VListItem>
    </VList>
  </div>
</template>

<style scoped></style>
